import { ModalDialog } from '@aboutyou/legacy-shared/src/ui/utilityComponents/ModalDialog/ModalDialog'
import { useCategoryLinks } from 'pages/Welcome/hooks/use-category-links'
import React, { useState } from 'react'
import { IconName } from 'uiComponents/atoms/Icon/IconName'
import {
  ContentBannerSection,
  ContentSectionButton,
  ContentSectionButtonsHolder,
  ContentSectionCtaHolder,
  ContentSectionHeaderWide,
  ContentSectionOverlay,
  ContentSectionSubHeaderWide,
  StyledInfoIcon,
  TeaserBackground,
} from './content-styles'

export const MajorCampaignContentGenderSelectBanner: React.FC<{
  campaignImage?: string
  headline?: string
  subline?: string
  campaignConditions: string | boolean | null
  fallbackColor: string | null
}> = ({
  campaignImage,
  headline,
  subline,
  campaignConditions,
  fallbackColor,
}) => {
  const [showCampaignDetails, setShowCampaignDetails] = useState<boolean>(false)
  const categoryLinks = useCategoryLinks()

  return (
    <>
      <ContentBannerSection isWide data-testid="ContentGenderSelectBanner">
        <TeaserBackground src={campaignImage} height={100} width={100} />
        <ContentSectionOverlay
          wide
          // only apply fallbackColor when there is no backgroundImage available
          {...(!campaignImage && {
            fallbackColor,
          })}
        >
          <ContentSectionCtaHolder>
            <ContentSectionSubHeaderWide style={{ margin: 0 }}>
              {subline}
            </ContentSectionSubHeaderWide>
            <ContentSectionHeaderWide style={{ marginTop: '16px' }}>
              {headline}

              {campaignConditions && (
                <StyledInfoIcon
                  asset={IconName.IcInfo}
                  onClick={() => setShowCampaignDetails(true)}
                />
              )}
            </ContentSectionHeaderWide>
            <ContentSectionButtonsHolder>
              {categoryLinks.map((categoryLink, i) => (
                <ContentSectionButton
                  key={`${categoryLink.title}-${i}`}
                  data-testid="Link"
                  href={categoryLink.link}
                >
                  {categoryLink.title}
                </ContentSectionButton>
              ))}
            </ContentSectionButtonsHolder>
          </ContentSectionCtaHolder>
        </ContentSectionOverlay>
      </ContentBannerSection>

      <ModalDialog
        open={showCampaignDetails}
        onClose={() => setShowCampaignDetails(false)}
        showCloseIcon
        styles={{
          modal: {
            alignSelf: 'center',
            height: 'auto',
            padding: '30px 20px',
            top: 0,
            width: '40%',
          },
        }}
      >
        {campaignConditions}
      </ModalDialog>
    </>
  )
}
